import { CommonMappingData, IBulletConfirmationStatusChangeResponse } from '../integrationlayer/api.model';
import { Address } from '../address/address.model';

export type ICAInformationRequestMappingData = CommonMappingData;
// tslint:disable-next-line:no-empty-interface
export type ICAInformationRequestStatusResponse = IBulletConfirmationStatusChangeResponse;

export interface ICAInformationRequestDTO {
  mappingData: ICAInformationRequestMappingData[];
  address: Address;
  customerDataChangeData?: { email: string; customerNumbers: string[] };
  kindOfInformation: string;
  timeRangeType: string;
  timeRangeFrom?: string;
  timeRangeTo?: string;
  infoRecipientEmail: string;
  processStatus?: string;
  createdAt?: string;
}

export const parseCAInformationRequestDTOFromOrderStatusDetail = (caInformationRequestDetails: any): ICAInformationRequestDTO => {
  return JSON.parse(caInformationRequestDetails.changeData);
};
